// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l6Fx","toggle":"styles_toggle__1AT4v","preview":"styles_preview__35A7E"};